// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { itemDetailSchema } from '@/items/api/types';
import { z } from 'zod';

const deleteItemPricingResponseSchema = z
  .object({ data: itemDetailSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, item: data }));

export type DeleteItemPricingResponse = z.infer<
  typeof deleteItemPricingResponseSchema
>;

export async function deleteItemPricing(
  itemKey: string
): Promise<DeleteItemPricingResponse> {
  const url = `/v1/catalog/item/${itemKey}/pricing`;
  const response = await api.delete(url);
  return parseResponse(deleteItemPricingResponseSchema, response.data, {
    schemaName: 'DeleteItemPricing',
    endpoint: url,
  });
}
